import {Skeleton} from '@mui/material';

type TagsSelectionType = {
  skeletonChips: number;
};
const TagsSkeleton = ({skeletonChips}: TagsSelectionType) =>
  [...new Array(skeletonChips)].map((_, index) => (
    <Skeleton
      key={`sk_chip_${index}`}
      variant="rounded"
      width={index % 2 ? '25%' : '20%'}
      height={32}
      sx={{
        mt: {xxs: 0, md: 1},
        ml: {xxs: 2, md: 'none'},
        mb: 1,
        borderRadius: 4,
      }}
    />
  ));

export default TagsSkeleton;
